module.exports = __webpack_public_path__ + "fonts/fa-solid-900.9451d5f.woff2";